import { StateButtonModule } from './../../widgets/state-button/state-button.module';
import { DirectivesModule } from 'src/app/directives/directives/directives.module';
import { TreeViewModule } from './../../widgets/tree-view/tree-view.module';
import { ProjectGanttViewModule } from './../../widgets/project-gantt-view/project-gantt-view.module';
import { InfoHeaderModule } from './../../widgets/info-header/info-header.module';
import { ButtonGroupModule } from './../../widgets/button-group/button-group.module';
import { PostTextEditorModule } from './post-text-editor/post-text-editor.module';
import { NewPostPopupModule } from './new-post-popup/new-post-popup.module';
import { PostCardModule } from './post-card/post-card.module';
import { KpiCardModule } from './kpi-card/kpi-card.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HomeRoutingModule } from './home-routing.module';
import { HomeComponent } from './home.component';
import { DxDataGridModule } from 'devextreme-angular/ui/data-grid';
import { HttpClient } from '@angular/common/http';
import { DxLoadPanelModule, DxPopupModule, DxButtonModule, DxButtonGroupModule } from 'devextreme-angular';
import { ContainerComponent } from 'src/app/components/container/container.component';

@NgModule({
	declarations: [HomeComponent],
	imports: [
		CommonModule,
		DirectivesModule,

		HomeRoutingModule,
		KpiCardModule,
		PostCardModule,
		NewPostPopupModule,
		PostTextEditorModule,
		DxButtonGroupModule,
		DxDataGridModule,
		DxLoadPanelModule,
		DxPopupModule,
		DxButtonModule,
		ButtonGroupModule,
		InfoHeaderModule,
		ProjectGanttViewModule,

		TreeViewModule,
		StateButtonModule,
		ContainerComponent,
	],
	providers: [HttpClient]
})
export class HomeModule { }
